import { API_CALL } from '../actions/actionTypes'
import simpleEntityApi from './simpleEntityApi'
import translatedEntityApi from './translatedEntityApi'
import ingrediends from './ingredients'
import recipes from './recipes'
import labelLevels from './labelLevels'
import session from './session'
import users from './users'

export const apiAction = apiObject => ( params, options, headers ) => ({
  type: API_CALL,
  apiObject,
  params,
  options,
  headers,
})

export const apiActionWithRoute = apiObject => route => ( params, options, headers ) => ({
  type: API_CALL,
  apiObject,
  params,
  route,
  options,
  headers,
})

const mergedApi = {
  ...simpleEntityApi('locale'),
  ...translatedEntityApi('region'),
  ...translatedEntityApi('appliance'),
  ...simpleEntityApi('applianceType'),
  ...translatedEntityApi('foodKind'),
  ...translatedEntityApi('libraryText'),
  ...translatedEntityApi('tag'),
  ...simpleEntityApi('tagType'),
  ...translatedEntityApi('unit'),
  ...ingrediends,
  ...recipes,
  ...labelLevels,
  ...session,
  ...users,
}

const api = Reflect.ownKeys(mergedApi).reduce((result, field) => {
  result[field] = {
    ...mergedApi[field],
    // add constants to generate actions on request lifecycle
    request: `api.${field}.request`,
    success: `api.${field}.success`,
    failure: `api.${field}.failure`,
  }

  return result
}, {})

export default api
